import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	Interactive,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

const TimelineRightTrimCapture = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 30) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(331 / 30) * fps}
			style={{
				width: 1894,
				height: 1118,
			}}
		>
			<Video
				src="https://remotion.media/studio-close-ups/timeline-right-trim-005918e43672.mp4"
				durationInFrames={(331 / 30) * fps}
				muted
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(frame, [6, 28, 285], ['auto', 'custom', 'auto'], {
					easing: Easing.step1,
					extrapolateLeft: 'clamp',
					extrapolateRight: 'clamp',
				})}
				customCursor={interpolate(
					frame,
					[28, 280, 281, 283],
					[
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20transform%3D%22translate(32%200)%20scale(-1%201)%22%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, ew-resize',
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, ew-resize',
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20transform%3D%22translate(32%200)%20scale(-1%201)%22%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, ew-resize',
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M5%206H3V26H5M27%206H29V26H27M8%2016H24M8%2016L12%2012M8%2016L12%2020M24%2016L20%2012M24%2016L20%2020%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M5%206H3V26H5M27%206H29V26H27M8%2016H24M8%2016L12%2012M8%2016L12%2020M24%2016L20%2012M24%2016L20%2020%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E") 2 12, ew-resize',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 57, 263, 306, 309],
						[3.5, 3.15, 3.5, 3.15, 3.5],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
							23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
							39, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82,
							83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98,
							99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111,
							112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124,
							125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137,
							138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150,
							151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163,
							164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176,
							177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189,
							190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202,
							203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215,
							216, 217, 218, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230,
							231, 232, 233, 234, 235, 278, 279, 280, 281, 282, 283, 284, 285,
							286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298,
							299, 300,
						],
						[
							'1095.3359375px 1005.388671875px',
							'1095.3359375px 1005.388671875px',
							'1112.767578125px 900.5390625px',
							'1113.57421875px 807.802734375px',
							'1113.57421875px 807.802734375px',
							'1117.375px 763.41015625px',
							'1118.537109375px 753.1015625px',
							'1123.30859375px 734.548828125px',
							'1127.9296875px 722.380859375px',
							'1131.94921875px 709.556640625px',
							'1135.421875px 698.318359375px',
							'1139.9609375px 686.1640625px',
							'1144.52734375px 671.125px',
							'1150.92578125px 659.298828125px',
							'1157.48828125px 646.65234375px',
							'1162.068359375px 633.322265625px',
							'1165.30859375px 621.537109375px',
							'1168.42578125px 606.7578125px',
							'1172.52734375px 597.857421875px',
							'1172.52734375px 597.857421875px',
							'1181.208984375px 583.419921875px',
							'1186.9375px 576.939453125px',
							'1190.369140625px 573.015625px',
							'1190.369140625px 573.015625px',
							'1196.029296875px 566.09765625px',
							'1198.927734375px 562.447265625px',
							'1201.40234375px 559.37109375px',
							'1203.931640625px 556.814453125px',
							'1206.611328125px 554.44921875px',
							'1207.759765625px 553.287109375px',
							'1208.361328125px 552.658203125px',
							'1208.8125px 552.1796875px',
							'1209.400390625px 551.263671875px',
							'1209.4140625px 550.908203125px',
							'1209.4140625px 550.908203125px',
							'1208.087890625px 550.908203125px',
							'1206.1875px 550.908203125px',
							'1201.607421875px 550.908203125px',
							'1198.28515625px 551.236328125px',
							'1196.8359375px 551.44140625px',
							'1193.404296875px 551.810546875px',
							'1193.404296875px 551.810546875px',
							'1187.005859375px 552.494140625px',
							'1183.943359375px 552.712890625px',
							'1183.943359375px 552.712890625px',
							'1179.623046875px 553.2734375px',
							'1172.158203125px 554.462890625px',
							'1172.158203125px 554.462890625px',
							'1167.427734375px 555.1328125px',
							'1164.26953125px 555.5703125px',
							'1162.109375px 555.912109375px',
							'1159.525390625px 556.294921875px',
							'1159.525390625px 556.294921875px',
							'1158.390625px 556.294921875px',
							'1154.53515625px 556.74609375px',
							'1152.23828125px 556.74609375px',
							'1150.146484375px 556.923828125px',
							'1150.146484375px 556.923828125px',
							'1147.658203125px 557.15625px',
							'1143.26953125px 557.51171875px',
							'1140.849609375px 557.771484375px',
							'1140.849609375px 557.771484375px',
							'1137.47265625px 557.771484375px',
							'1131.826171875px 557.771484375px',
							'1129.173828125px 557.771484375px',
							'1129.173828125px 557.771484375px',
							'1124.169921875px 557.771484375px',
							'1121.640625px 558.1953125px',
							'1119.658203125px 558.1953125px',
							'1119.658203125px 558.1953125px',
							'1115.625px 558.4140625px',
							'1113.65625px 558.5234375px',
							'1110.9765625px 558.5234375px',
							'1110.9765625px 558.5234375px',
							'1107.763671875px 558.865234375px',
							'1106.013671875px 558.865234375px',
							'1105.125px 558.865234375px',
							'1103.703125px 559.20703125px',
							'1100.763671875px 559.20703125px',
							'1098.453125px 559.20703125px',
							'1096.9765625px 559.20703125px',
							'1095.595703125px 559.20703125px',
							'1094.228515625px 559.20703125px',
							'1091.248046875px 559.20703125px',
							'1089.78515625px 559.20703125px',
							'1088.212890625px 559.521484375px',
							'1086.162109375px 559.548828125px',
							'1086.162109375px 559.548828125px',
							'1082.78515625px 559.548828125px',
							'1078.123046875px 559.8359375px',
							'1076.49609375px 559.8359375px',
							'1073.638671875px 559.8359375px',
							'1073.638671875px 559.8359375px',
							'1068.361328125px 559.8359375px',
							'1066.078125px 559.8359375px',
							'1066.078125px 559.8359375px',
							'1059.365234375px 559.8359375px',
							'1056.384765625px 559.8359375px',
							'1056.384765625px 559.8359375px',
							'1052.1328125px 559.8359375px',
							'1050.62890625px 559.8359375px',
							'1048.82421875px 559.8359375px',
							'1048.82421875px 559.8359375px',
							'1040.94921875px 559.8359375px',
							'1038.529296875px 559.8359375px',
							'1038.529296875px 559.8359375px',
							'1032.978515625px 559.8359375px',
							'1031.474609375px 559.8359375px',
							'1026.716796875px 559.8359375px',
							'1026.716796875px 559.8359375px',
							'1019.6484375px 560.1640625px',
							'1014.548828125px 560.1640625px',
							'1014.548828125px 560.1640625px',
							'1009.189453125px 560.1640625px',
							'1004.5546875px 560.4921875px',
							'1004.5546875px 560.4921875px',
							'997.5546875px 560.751953125px',
							'997.5546875px 560.751953125px',
							'985.00390625px 560.84765625px',
							'977.8125px 560.84765625px',
							'977.8125px 560.84765625px',
							'969.6640625px 560.84765625px',
							'969.6640625px 560.84765625px',
							'964.236328125px 561.17578125px',
							'960.96875px 561.17578125px',
							'960.96875px 561.17578125px',
							'953.99609375px 561.17578125px',
							'950.755859375px 561.17578125px',
							'950.755859375px 561.17578125px',
							'945.24609375px 561.44921875px',
							'941.28125px 561.873046875px',
							'936.60546875px 561.88671875px',
							'934.404296875px 561.88671875px',
							'934.404296875px 561.88671875px',
							'930.3984375px 561.88671875px',
							'927.650390625px 561.88671875px',
							'923.412109375px 561.88671875px',
							'923.412109375px 561.88671875px',
							'918.408203125px 561.88671875px',
							'913.814453125px 561.88671875px',
							'912.310546875px 561.88671875px',
							'912.310546875px 561.88671875px',
							'909.330078125px 561.88671875px',
							'906.240234375px 561.88671875px',
							'905.419921875px 561.88671875px',
							'904.490234375px 561.88671875px',
							'902.453125px 561.88671875px',
							'901.4140625px 561.88671875px',
							'900.443359375px 561.490234375px',
							'899.458984375px 561.435546875px',
							'899.021484375px 561.435546875px',
							'897.12109375px 561.435546875px',
							'896.41015625px 561.435546875px',
							'895.7265625px 561.435546875px',
							'895.7265625px 561.435546875px',
							'892.69140625px 561.435546875px',
							'891.59765625px 561.435546875px',
							'890.859375px 561.435546875px',
							'888.69921875px 561.435546875px',
							'887.7421875px 561.435546875px',
							'887.140625px 561.435546875px',
							'886.703125px 561.435546875px',
							'886.703125px 561.435546875px',
							'885.458984375px 561.435546875px',
							'884.283203125px 561.435546875px',
							'883.09375px 561.435546875px',
							'881.986328125px 561.435546875px',
							'880.9609375px 561.435546875px',
							'880.099609375px 561.435546875px',
							'879.703125px 561.435546875px',
							'879.224609375px 561.435546875px',
							'878.828125px 561.435546875px',
							'878.4453125px 561.435546875px',
							'877.81640625px 561.435546875px',
							'877.81640625px 561.435546875px',
							'876.50390625px 561.517578125px',
							'875.8203125px 561.818359375px',
							'875.560546875px 561.818359375px',
							'874.958984375px 561.818359375px',
							'874.494140625px 561.818359375px',
							'873.93359375px 561.845703125px',
							'872.73046875px 562.201171875px',
							'872.416015625px 562.201171875px',
							'871.609375px 562.501953125px',
							'871.2265625px 562.583984375px',
							'871.2265625px 562.583984375px',
							'870.76171875px 562.583984375px',
							'869.408203125px 563.0078125px',
							'869.408203125px 563.0078125px',
							'867.083984375px 563.185546875px',
							'867.083984375px 563.185546875px',
							'865.525390625px 563.36328125px',
							'864.595703125px 563.36328125px',
							'863.953125px 563.36328125px',
							'863.173828125px 563.36328125px',
							'861.451171875px 563.71875px',
							'860.80859375px 563.71875px',
							'860.193359375px 563.71875px',
							'860.193359375px 563.71875px',
							'858.908203125px 563.71875px',
							'858.908203125px 563.71875px',
							'860.302734375px 571.51171875px',
							'864.171875px 580.630859375px',
							'877.65234375px 609.560546875px',
							'877.65234375px 609.560546875px',
							'914.046875px 720.494140625px',
							'914.046875px 720.494140625px',
							'1000.630859375px 960.080078125px',
							'1022.8203125px 1031.173828125px',
							'1022.8203125px 1031.173828125px',
							'1026.443359375px 1037.83203125px',
							'1032.47265625px 1041.345703125px',
							'1035.111328125px 1042.5078125px',
							'1035.111328125px 1042.5078125px',
							'1044.5859375px 1056.466796875px',
							'1050.533203125px 1073.1875px',
							'1060.650390625px 1092.833984375px',
							'1069.837890625px 1103.8671875px',
							'1072.28515625px 1105.3984375px',
							'1072.28515625px 1105.3984375px',
							'1078.533203125px 1104.044921875px',
							'1081.63671875px 1102.732421875px',
							'1081.978515625px 1102.650390625px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

const TimelineRightTrimContent = () => {
	const {width, height} = useVideoConfig();

	return (
		<Interactive.Div
			name="Right trim - angled camera"
			style={{
				position: 'absolute',
				width: 1894,
				height: 1118,
				left: '50%',
				top: '50%',
				translate: '-1010px -535px',
				transformOrigin: '1010px 535px',
				rotate: '0.35 1 0.3 20deg',
				scale: Math.min(width / 2560, height / 1600) * 2.1,
			}}
		>
			<TimelineRightTrimCapture />
		</Interactive.Div>
	);
};

export const TimelineRightTrimComposition = Interactive.create({
	Component: TimelineRightTrimContent,
	layout: 'absolute-fill',
	schema: {...Interactive.backgroundSchema},
});
